module.exports = __webpack_public_path__ + "media/components/helpcenter/InsightsHelp/InsightIncident3-3febcd4dfb0eba035b747e402ae8f325.jpg";